// Navigation trees per layout, parsed from the `menuData` declared in each raw layout shell.
// Items reference pages by pageId; routes are resolved by slug through ./menuData.js.
const GENERATED_LAYOUT_MENUS = {
 "_anonymous-web-layout-18yitw0": {
  "items": [
   {
    "label": "System Administration",
    "icon": "fas fa-cogs",
    "bottomBar": false,
    "children": [
     {
      "label": "Users & Access Control",
      "icon": "fas fa-users-cog",
      "pageId": 73909,
      "bottomBar": false
     },
     {
      "label": "Security & Permissions",
      "icon": "fas fa-user-lock",
      "pageId": 73911,
      "bottomBar": false
     },
     {
      "label": "Audit Trail Explorer",
      "icon": "fas fa-shield-alt",
      "pageId": 73924,
      "bottomBar": false
     },
     {
      "label": "Tenant Branding",
      "icon": "fas fa-paint-brush",
      "pageId": 73927,
      "bottomBar": false
     },
     {
      "label": "Webhooks & Integrations",
      "icon": "fas fa-network-wired",
      "pageId": 73931,
      "bottomBar": false
     }
    ]
   },
   {
    "label": "Dashboards & Triage",
    "icon": "fas fa-tachometer-alt",
    "bottomBar": false,
    "children": [
     {
      "label": "Kanban Triage Board",
      "icon": "fas fa-columns",
      "pageId": 73915,
      "bottomBar": true
     },
     {
      "label": "Executive SLA Dashboard",
      "icon": "fas fa-chart-line",
      "pageId": 73923,
      "bottomBar": true
     }
    ]
   },
   {
    "label": "Defect Intake",
    "icon": "fas fa-inbox",
    "bottomBar": false,
    "children": [
     {
      "label": "Resident Portal",
      "icon": "fas fa-home",
      "pageId": 73912,
      "bottomBar": true
     },
     {
      "label": "Service Desk Console",
      "icon": "fas fa-headset",
      "pageId": 73913,
      "bottomBar": false
     },
     {
      "label": "QR Defect Intake PWA",
      "icon": "fas fa-qrcode",
      "pageId": 73914,
      "bottomBar": true
     }
    ]
   },
   {
    "label": "Work Orders & Field",
    "icon": "fas fa-tools",
    "bottomBar": false,
    "children": [
     {
      "label": "Work Order Dispatch",
      "icon": "fas fa-clipboard-list",
      "pageId": 73916,
      "bottomBar": true
     },
     {
      "label": "Inspection Templates",
      "icon": "fas fa-clipboard-check",
      "pageId": 73932,
      "bottomBar": false
     },
     {
      "label": "Technician Mobile PWA",
      "icon": "fas fa-wrench",
      "pageId": 73920,
      "bottomBar": true
     },
     {
      "label": "Dual Sign-Off & Review",
      "icon": "fas fa-signature",
      "pageId": 73921,
      "bottomBar": true
     }
    ]
   },
   {
    "label": "Quotations & Approvals",
    "icon": "fas fa-file-invoice-dollar",
    "bottomBar": false,
    "children": [
     {
      "label": "Quotation Builder",
      "icon": "fas fa-calculator",
      "pageId": 73919,
      "bottomBar": false
     },
     {
      "label": "Approvals Queue & AP",
      "icon": "fas fa-check-double",
      "pageId": 73922,
      "bottomBar": true
     }
    ]
   },
   {
    "label": "Contractor Management",
    "icon": "fas fa-hard-hat",
    "bottomBar": false,
    "children": [
     {
      "label": "Trade Rate Cards",
      "icon": "fas fa-tags",
      "pageId": 73917,
      "bottomBar": false
     },
     {
      "label": "Provider Compliance",
      "icon": "fas fa-id-card",
      "pageId": 73918,
      "bottomBar": false
     },
     {
      "label": "Performance Scorecards",
      "icon": "fas fa-medal",
      "pageId": 73926,
      "bottomBar": false
     }
    ]
   },
   {
    "label": "Hierarchy & Assets",
    "icon": "fas fa-building",
    "bottomBar": false,
    "children": [
     {
      "label": "Spatial Property Tree",
      "icon": "fas fa-sitemap",
      "pageId": 73925,
      "bottomBar": false
     },
     {
      "label": "Batch QR Placards",
      "icon": "fas fa-qrcode",
      "pageId": 73928,
      "bottomBar": false
     }
    ]
   },
   {
    "label": "Billing & Subscriptions",
    "icon": "fas fa-credit-card",
    "bottomBar": false,
    "children": [
     {
      "label": "Subscription & Seats",
      "icon": "fas fa-layer-group",
      "pageId": 73929,
      "bottomBar": false
     },
     {
      "label": "Invoicing & Payments",
      "icon": "fas fa-receipt",
      "pageId": 73930,
      "bottomBar": false
     }
    ]
   }
  ],
  "defaultPageId": 73923
 },
 "_anonymous-web-layout": {
  "items": [
   {
    "label": "System Administration",
    "icon": "fas fa-cogs",
    "bottomBar": false,
    "children": [
     {
      "label": "Users & Access Control",
      "icon": "fas fa-users-cog",
      "pageId": 73909,
      "bottomBar": false
     },
     {
      "label": "Security & Permissions",
      "icon": "fas fa-user-lock",
      "pageId": 73911,
      "bottomBar": false
     },
     {
      "label": "Audit Trail Explorer",
      "icon": "fas fa-shield-alt",
      "pageId": 73924,
      "bottomBar": false
     },
     {
      "label": "Tenant Branding",
      "icon": "fas fa-paint-brush",
      "pageId": 73927,
      "bottomBar": false
     },
     {
      "label": "Webhooks & Integrations",
      "icon": "fas fa-network-wired",
      "pageId": 73931,
      "bottomBar": false
     }
    ]
   },
   {
    "label": "Dashboards & Triage",
    "icon": "fas fa-tachometer-alt",
    "bottomBar": false,
    "children": [
     {
      "label": "Kanban Triage Board",
      "icon": "fas fa-columns",
      "pageId": 73915,
      "bottomBar": true
     },
     {
      "label": "Executive SLA Dashboard",
      "icon": "fas fa-chart-line",
      "pageId": 73923,
      "bottomBar": true
     }
    ]
   },
   {
    "label": "Defect Intake",
    "icon": "fas fa-inbox",
    "bottomBar": false,
    "children": [
     {
      "label": "Resident Portal",
      "icon": "fas fa-home",
      "pageId": 73912,
      "bottomBar": true
     },
     {
      "label": "Service Desk Console",
      "icon": "fas fa-headset",
      "pageId": 73913,
      "bottomBar": false
     },
     {
      "label": "QR Defect Intake PWA",
      "icon": "fas fa-qrcode",
      "pageId": 73914,
      "bottomBar": true
     }
    ]
   },
   {
    "label": "Work Orders & Field",
    "icon": "fas fa-tools",
    "bottomBar": false,
    "children": [
     {
      "label": "Work Order Dispatch",
      "icon": "fas fa-clipboard-list",
      "pageId": 73916,
      "bottomBar": true
     },
     {
      "label": "Inspection Templates",
      "icon": "fas fa-clipboard-check",
      "pageId": 73932,
      "bottomBar": false
     },
     {
      "label": "Technician Mobile PWA",
      "icon": "fas fa-wrench",
      "pageId": 73920,
      "bottomBar": true
     },
     {
      "label": "Dual Sign-Off & Review",
      "icon": "fas fa-signature",
      "pageId": 73921,
      "bottomBar": true
     }
    ]
   },
   {
    "label": "Quotations & Approvals",
    "icon": "fas fa-file-invoice-dollar",
    "bottomBar": false,
    "children": [
     {
      "label": "Quotation Builder",
      "icon": "fas fa-calculator",
      "pageId": 73919,
      "bottomBar": false
     },
     {
      "label": "Approvals Queue & AP",
      "icon": "fas fa-check-double",
      "pageId": 73922,
      "bottomBar": true
     }
    ]
   },
   {
    "label": "Contractor Management",
    "icon": "fas fa-hard-hat",
    "bottomBar": false,
    "children": [
     {
      "label": "Trade Rate Cards",
      "icon": "fas fa-tags",
      "pageId": 73917,
      "bottomBar": false
     },
     {
      "label": "Provider Compliance",
      "icon": "fas fa-id-card",
      "pageId": 73918,
      "bottomBar": false
     },
     {
      "label": "Performance Scorecards",
      "icon": "fas fa-medal",
      "pageId": 73926,
      "bottomBar": false
     }
    ]
   },
   {
    "label": "Hierarchy & Assets",
    "icon": "fas fa-building",
    "bottomBar": false,
    "children": [
     {
      "label": "Spatial Property Tree",
      "icon": "fas fa-sitemap",
      "pageId": 73925,
      "bottomBar": false
     },
     {
      "label": "Batch QR Placards",
      "icon": "fas fa-qrcode",
      "pageId": 73928,
      "bottomBar": false
     }
    ]
   },
   {
    "label": "Billing & Subscriptions",
    "icon": "fas fa-credit-card",
    "bottomBar": false,
    "children": [
     {
      "label": "Subscription & Seats",
      "icon": "fas fa-layer-group",
      "pageId": 73929,
      "bottomBar": false
     },
     {
      "label": "Invoicing & Payments",
      "icon": "fas fa-receipt",
      "pageId": 73930,
      "bottomBar": false
     }
    ]
   }
  ],
  "defaultPageId": 73923
 },
 "_batch-qr-code-generator-asset-placards-layout": {
  "items": [
   {
    "label": "System Administration",
    "icon": "fas fa-cogs",
    "bottomBar": false,
    "children": [
     {
      "label": "Users & Access Control",
      "icon": "fas fa-users-cog",
      "pageId": 73909,
      "bottomBar": false
     },
     {
      "label": "Tenant Branding",
      "icon": "fas fa-paint-brush",
      "pageId": 73927,
      "bottomBar": false
     }
    ]
   },
   {
    "label": "Work Orders & Field",
    "icon": "fas fa-tools",
    "bottomBar": false,
    "children": [
     {
      "label": "Inspection Templates",
      "icon": "fas fa-clipboard-check",
      "pageId": 73932,
      "bottomBar": false
     }
    ]
   },
   {
    "label": "Contractor Management",
    "icon": "fas fa-hard-hat",
    "bottomBar": false,
    "children": [
     {
      "label": "Trade Rate Cards",
      "icon": "fas fa-tags",
      "pageId": 73917,
      "bottomBar": false
     }
    ]
   },
   {
    "label": "Hierarchy & Assets",
    "icon": "fas fa-building",
    "bottomBar": false,
    "children": [
     {
      "label": "Spatial Property Tree",
      "icon": "fas fa-sitemap",
      "pageId": 73925,
      "bottomBar": false
     },
     {
      "label": "Batch QR Placards",
      "icon": "fas fa-qrcode",
      "pageId": 73928,
      "bottomBar": false
     }
    ]
   },
   {
    "label": "Dashboards & Triage",
    "icon": "fas fa-tachometer-alt",
    "bottomBar": false,
    "children": [
     {
      "label": "Executive SLA Dashboard",
      "icon": "fas fa-chart-line",
      "pageId": 73923,
      "bottomBar": true
     }
    ]
   },
   {
    "label": "Billing & Subscriptions",
    "icon": "fas fa-credit-card",
    "bottomBar": false,
    "children": [
     {
      "label": "Subscription & Seats",
      "icon": "fas fa-layer-group",
      "pageId": 73929,
      "bottomBar": false
     },
     {
      "label": "Invoicing & Payments",
      "icon": "fas fa-receipt",
      "pageId": 73930,
      "bottomBar": false
     }
    ]
   }
  ],
  "defaultPageId": 73923
 },
 "_compliance-audit-trail-explorer-layout": {
  "items": [
   {
    "label": "System Administration",
    "icon": "fas fa-cogs",
    "bottomBar": false,
    "children": [
     {
      "label": "Users & Access Control",
      "icon": "fas fa-users-cog",
      "pageId": 73909,
      "bottomBar": false
     },
     {
      "label": "Security & Permissions",
      "icon": "fas fa-user-lock",
      "pageId": 73911,
      "bottomBar": false
     },
     {
      "label": "Audit Trail Explorer",
      "icon": "fas fa-shield-alt",
      "pageId": 73924,
      "bottomBar": false
     },
     {
      "label": "Tenant Branding",
      "icon": "fas fa-paint-brush",
      "pageId": 73927,
      "bottomBar": false
     },
     {
      "label": "Webhooks & Integrations",
      "icon": "fas fa-network-wired",
      "pageId": 73931,
      "bottomBar": false
     }
    ]
   },
   {
    "label": "Hierarchy & Assets",
    "icon": "fas fa-building",
    "bottomBar": false,
    "children": [
     {
      "label": "Spatial Property Tree",
      "icon": "fas fa-sitemap",
      "pageId": 73925,
      "bottomBar": false
     }
    ]
   },
   {
    "label": "Dashboards & Triage",
    "icon": "fas fa-tachometer-alt",
    "bottomBar": false,
    "children": [
     {
      "label": "Executive SLA Dashboard",
      "icon": "fas fa-chart-line",
      "pageId": 73923,
      "bottomBar": true
     }
    ]
   }
  ],
  "defaultPageId": 73923
 },
 "_default-web-layout-1n801y6": {
  "items": [
   {
    "label": "Dashboards & Triage",
    "icon": "fas fa-tachometer-alt",
    "bottomBar": false,
    "children": [
     {
      "label": "Kanban Triage Board",
      "icon": "fas fa-columns",
      "pageId": 73915,
      "bottomBar": true
     },
     {
      "label": "Executive SLA Dashboard",
      "icon": "fas fa-chart-line",
      "pageId": 73923,
      "bottomBar": true
     }
    ]
   },
   {
    "label": "Defect Intake",
    "icon": "fas fa-inbox",
    "bottomBar": false,
    "children": [
     {
      "label": "Service Desk Console",
      "icon": "fas fa-headset",
      "pageId": 73913,
      "bottomBar": false
     }
    ]
   },
   {
    "label": "Work Orders & Field",
    "icon": "fas fa-tools",
    "bottomBar": false,
    "children": [
     {
      "label": "Work Order Dispatch",
      "icon": "fas fa-clipboard-list",
      "pageId": 73916,
      "bottomBar": true
     },
     {
      "label": "Inspection Templates",
      "icon": "fas fa-clipboard-check",
      "pageId": 73932,
      "bottomBar": false
     },
     {
      "label": "Dual Sign-Off & Review",
      "icon": "fas fa-signature",
      "pageId": 73921,
      "bottomBar": true
     }
    ]
   },
   {
    "label": "Quotations & Approvals",
    "icon": "fas fa-file-invoice-dollar",
    "bottomBar": false,
    "children": [
     {
      "label": "Approvals Queue & AP",
      "icon": "fas fa-check-double",
      "pageId": 73922,
      "bottomBar": true
     }
    ]
   },
   {
    "label": "Contractor Management",
    "icon": "fas fa-hard-hat",
    "bottomBar": false,
    "children": [
     {
      "label": "Performance Scorecards",
      "icon": "fas fa-medal",
      "pageId": 73926,
      "bottomBar": false
     }
    ]
   },
   {
    "label": "Billing & Subscriptions",
    "icon": "fas fa-credit-card",
    "bottomBar": false,
    "children": [
     {
      "label": "Subscription & Seats",
      "icon": "fas fa-layer-group",
      "pageId": 73929,
      "bottomBar": false
     },
     {
      "label": "Invoicing & Payments",
      "icon": "fas fa-receipt",
      "pageId": 73930,
      "bottomBar": false
     }
    ]
   }
  ],
  "defaultPageId": 73923
 },
 "_default-web-layout-3rhmrt": {
  "items": [
   {
    "label": "Work Orders & Field",
    "icon": "fas fa-tools",
    "bottomBar": false,
    "children": [
     {
      "label": "Technician Mobile PWA",
      "icon": "fas fa-wrench",
      "pageId": 73920,
      "bottomBar": true
     },
     {
      "label": "Dual Sign-Off & Review",
      "icon": "fas fa-signature",
      "pageId": 73921,
      "bottomBar": true
     }
    ]
   }
  ],
  "defaultPageId": null
 },
 "_default-web-layout-cevls9": {
  "items": [
   {
    "label": "Defect Intake",
    "icon": "fas fa-inbox",
    "bottomBar": false,
    "children": [
     {
      "label": "Resident Portal",
      "icon": "fas fa-home",
      "pageId": 73912,
      "bottomBar": true
     },
     {
      "label": "QR Defect Intake PWA",
      "icon": "fas fa-qrcode",
      "pageId": 73914,
      "bottomBar": true
     }
    ]
   },
   {
    "label": "Work Orders & Field",
    "icon": "fas fa-tools",
    "bottomBar": false,
    "children": [
     {
      "label": "Dual Sign-Off & Review",
      "icon": "fas fa-signature",
      "pageId": 73921,
      "bottomBar": true
     }
    ]
   }
  ],
  "defaultPageId": null
 },
 "_default-web-layout-ms5erx": {
  "items": [
   {
    "label": "Quotations & Approvals",
    "icon": "fas fa-file-invoice-dollar",
    "bottomBar": false,
    "children": [
     {
      "label": "Quotation Builder",
      "icon": "fas fa-calculator",
      "pageId": 73919,
      "bottomBar": false
     }
    ]
   },
   {
    "label": "Contractor Management",
    "icon": "fas fa-hard-hat",
    "bottomBar": false,
    "children": [
     {
      "label": "Trade Rate Cards",
      "icon": "fas fa-tags",
      "pageId": 73917,
      "bottomBar": false
     },
     {
      "label": "Provider Compliance",
      "icon": "fas fa-id-card",
      "pageId": 73918,
      "bottomBar": false
     }
    ]
   }
  ],
  "defaultPageId": null
 },
 "_default-web-layout-qmfpft": {
  "items": [
   {
    "label": "Dashboards & Triage",
    "icon": "fas fa-tachometer-alt",
    "bottomBar": false,
    "children": [
     {
      "label": "Kanban Triage Board",
      "icon": "fas fa-columns",
      "pageId": 73915,
      "bottomBar": true
     }
    ]
   },
   {
    "label": "Defect Intake",
    "icon": "fas fa-inbox",
    "bottomBar": false,
    "children": [
     {
      "label": "Service Desk Console",
      "icon": "fas fa-headset",
      "pageId": 73913,
      "bottomBar": false
     }
    ]
   },
   {
    "label": "Work Orders & Field",
    "icon": "fas fa-tools",
    "bottomBar": false,
    "children": [
     {
      "label": "Work Order Dispatch",
      "icon": "fas fa-clipboard-list",
      "pageId": 73916,
      "bottomBar": true
     },
     {
      "label": "Inspection Templates",
      "icon": "fas fa-clipboard-check",
      "pageId": 73932,
      "bottomBar": false
     },
     {
      "label": "Dual Sign-Off & Review",
      "icon": "fas fa-signature",
      "pageId": 73921,
      "bottomBar": true
     }
    ]
   },
   {
    "label": "Quotations & Approvals",
    "icon": "fas fa-file-invoice-dollar",
    "bottomBar": false,
    "children": [
     {
      "label": "Approvals Queue & AP",
      "icon": "fas fa-check-double",
      "pageId": 73922,
      "bottomBar": true
     }
    ]
   },
   {
    "label": "Contractor Management",
    "icon": "fas fa-hard-hat",
    "bottomBar": false,
    "children": [
     {
      "label": "Performance Scorecards",
      "icon": "fas fa-medal",
      "pageId": 73926,
      "bottomBar": false
     }
    ]
   }
  ],
  "defaultPageId": null
 },
 "_default-web-layout-roq9d5": {
  "items": [
   {
    "label": "Dashboards & Triage",
    "icon": "fas fa-tachometer-alt",
    "bottomBar": false,
    "children": [
     {
      "label": "Kanban Triage Board",
      "icon": "fas fa-columns",
      "pageId": 73915,
      "bottomBar": true
     }
    ]
   },
   {
    "label": "Defect Intake",
    "icon": "fas fa-inbox",
    "bottomBar": false,
    "children": [
     {
      "label": "Resident Portal",
      "icon": "fas fa-home",
      "pageId": 73912,
      "bottomBar": true
     },
     {
      "label": "Service Desk Console",
      "icon": "fas fa-headset",
      "pageId": 73913,
      "bottomBar": false
     },
     {
      "label": "QR Defect Intake PWA",
      "icon": "fas fa-qrcode",
      "pageId": 73914,
      "bottomBar": true
     }
    ]
   },
   {
    "label": "Work Orders & Field",
    "icon": "fas fa-tools",
    "bottomBar": false,
    "children": [
     {
      "label": "Work Order Dispatch",
      "icon": "fas fa-clipboard-list",
      "pageId": 73916,
      "bottomBar": true
     },
     {
      "label": "Inspection Templates",
      "icon": "fas fa-clipboard-check",
      "pageId": 73932,
      "bottomBar": false
     },
     {
      "label": "Technician Mobile PWA",
      "icon": "fas fa-wrench",
      "pageId": 73920,
      "bottomBar": true
     },
     {
      "label": "Dual Sign-Off & Review",
      "icon": "fas fa-signature",
      "pageId": 73921,
      "bottomBar": true
     }
    ]
   },
   {
    "label": "Quotations & Approvals",
    "icon": "fas fa-file-invoice-dollar",
    "bottomBar": false,
    "children": [
     {
      "label": "Approvals Queue & AP",
      "icon": "fas fa-check-double",
      "pageId": 73922,
      "bottomBar": true
     }
    ]
   },
   {
    "label": "Contractor Management",
    "icon": "fas fa-hard-hat",
    "bottomBar": false,
    "children": [
     {
      "label": "Performance Scorecards",
      "icon": "fas fa-medal",
      "pageId": 73926,
      "bottomBar": false
     }
    ]
   }
  ],
  "defaultPageId": null
 },
 "_default-web-layout": {
  "items": [
   {
    "label": "Dashboards & Triage",
    "icon": "fas fa-tachometer-alt",
    "bottomBar": false,
    "children": [
     {
      "label": "Kanban Triage Board",
      "icon": "fas fa-columns",
      "pageId": 73915,
      "bottomBar": true
     },
     {
      "label": "Executive SLA Dashboard",
      "icon": "fas fa-chart-line",
      "pageId": 73923,
      "bottomBar": true
     }
    ]
   },
   {
    "label": "Defect Intake",
    "icon": "fas fa-inbox",
    "bottomBar": false,
    "children": [
     {
      "label": "Service Desk Console",
      "icon": "fas fa-headset",
      "pageId": 73913,
      "bottomBar": false
     }
    ]
   },
   {
    "label": "Work Orders & Field",
    "icon": "fas fa-tools",
    "bottomBar": false,
    "children": [
     {
      "label": "Work Order Dispatch",
      "icon": "fas fa-clipboard-list",
      "pageId": 73916,
      "bottomBar": true
     },
     {
      "label": "Inspection Templates",
      "icon": "fas fa-clipboard-check",
      "pageId": 73932,
      "bottomBar": false
     },
     {
      "label": "Dual Sign-Off & Review",
      "icon": "fas fa-signature",
      "pageId": 73921,
      "bottomBar": true
     }
    ]
   },
   {
    "label": "Quotations & Approvals",
    "icon": "fas fa-file-invoice-dollar",
    "bottomBar": false,
    "children": [
     {
      "label": "Approvals Queue & AP",
      "icon": "fas fa-check-double",
      "pageId": 73922,
      "bottomBar": true
     }
    ]
   },
   {
    "label": "Contractor Management",
    "icon": "fas fa-hard-hat",
    "bottomBar": false,
    "children": [
     {
      "label": "Performance Scorecards",
      "icon": "fas fa-medal",
      "pageId": 73926,
      "bottomBar": false
     }
    ]
   }
  ],
  "defaultPageId": 73923
 },
 "_inspection-checklists-task-template-builder-layout": {
  "items": [
   {
    "label": "System Administration",
    "icon": "fas fa-cogs",
    "bottomBar": false,
    "children": [
     {
      "label": "Users & Access Control",
      "icon": "fas fa-users-cog",
      "pageId": 73909,
      "bottomBar": false
     },
     {
      "label": "Tenant Branding",
      "icon": "fas fa-paint-brush",
      "pageId": 73927,
      "bottomBar": false
     }
    ]
   },
   {
    "label": "Dashboards & Triage",
    "icon": "fas fa-tachometer-alt",
    "bottomBar": false,
    "children": [
     {
      "label": "Kanban Triage Board",
      "icon": "fas fa-columns",
      "pageId": 73915,
      "bottomBar": true
     },
     {
      "label": "Executive SLA Dashboard",
      "icon": "fas fa-chart-line",
      "pageId": 73923,
      "bottomBar": true
     }
    ]
   },
   {
    "label": "Defect Intake",
    "icon": "fas fa-inbox",
    "bottomBar": false,
    "children": [
     {
      "label": "Service Desk Console",
      "icon": "fas fa-headset",
      "pageId": 73913,
      "bottomBar": false
     }
    ]
   },
   {
    "label": "Work Orders & Field",
    "icon": "fas fa-tools",
    "bottomBar": false,
    "children": [
     {
      "label": "Work Order Dispatch",
      "icon": "fas fa-clipboard-list",
      "pageId": 73916,
      "bottomBar": true
     },
     {
      "label": "Inspection Templates",
      "icon": "fas fa-clipboard-check",
      "pageId": 73932,
      "bottomBar": false
     },
     {
      "label": "Dual Sign-Off & Review",
      "icon": "fas fa-signature",
      "pageId": 73921,
      "bottomBar": true
     }
    ]
   },
   {
    "label": "Quotations & Approvals",
    "icon": "fas fa-file-invoice-dollar",
    "bottomBar": false,
    "children": [
     {
      "label": "Approvals Queue & AP",
      "icon": "fas fa-check-double",
      "pageId": 73922,
      "bottomBar": true
     }
    ]
   },
   {
    "label": "Contractor Management",
    "icon": "fas fa-hard-hat",
    "bottomBar": false,
    "children": [
     {
      "label": "Trade Rate Cards",
      "icon": "fas fa-tags",
      "pageId": 73917,
      "bottomBar": false
     },
     {
      "label": "Performance Scorecards",
      "icon": "fas fa-medal",
      "pageId": 73926,
      "bottomBar": false
     }
    ]
   },
   {
    "label": "Hierarchy & Assets",
    "icon": "fas fa-building",
    "bottomBar": false,
    "children": [
     {
      "label": "Spatial Property Tree",
      "icon": "fas fa-sitemap",
      "pageId": 73925,
      "bottomBar": false
     },
     {
      "label": "Batch QR Placards",
      "icon": "fas fa-qrcode",
      "pageId": 73928,
      "bottomBar": false
     }
    ]
   },
   {
    "label": "Billing & Subscriptions",
    "icon": "fas fa-credit-card",
    "bottomBar": false,
    "children": [
     {
      "label": "Subscription & Seats",
      "icon": "fas fa-layer-group",
      "pageId": 73929,
      "bottomBar": false
     },
     {
      "label": "Invoicing & Payments",
      "icon": "fas fa-receipt",
      "pageId": 73930,
      "bottomBar": false
     }
    ]
   }
  ],
  "defaultPageId": 73923
 },
 "_operational-sla-maintenance-dashboard-layout": {
  "items": [
   {
    "label": "System Administration",
    "icon": "fas fa-cogs",
    "bottomBar": false,
    "children": [
     {
      "label": "Users & Access Control",
      "icon": "fas fa-users-cog",
      "pageId": 73909,
      "bottomBar": false
     },
     {
      "label": "Security & Permissions",
      "icon": "fas fa-user-lock",
      "pageId": 73911,
      "bottomBar": false
     },
     {
      "label": "Audit Trail Explorer",
      "icon": "fas fa-shield-alt",
      "pageId": 73924,
      "bottomBar": false
     },
     {
      "label": "Tenant Branding",
      "icon": "fas fa-paint-brush",
      "pageId": 73927,
      "bottomBar": false
     },
     {
      "label": "Webhooks & Integrations",
      "icon": "fas fa-network-wired",
      "pageId": 73931,
      "bottomBar": false
     }
    ]
   },
   {
    "label": "Dashboards & Triage",
    "icon": "fas fa-tachometer-alt",
    "bottomBar": false,
    "children": [
     {
      "label": "Kanban Triage Board",
      "icon": "fas fa-columns",
      "pageId": 73915,
      "bottomBar": true
     },
     {
      "label": "Executive SLA Dashboard",
      "icon": "fas fa-chart-line",
      "pageId": 73923,
      "bottomBar": true
     }
    ]
   },
   {
    "label": "Work Orders & Field",
    "icon": "fas fa-tools",
    "bottomBar": false,
    "children": [
     {
      "label": "Work Order Dispatch",
      "icon": "fas fa-clipboard-list",
      "pageId": 73916,
      "bottomBar": true
     },
     {
      "label": "Inspection Templates",
      "icon": "fas fa-clipboard-check",
      "pageId": 73932,
      "bottomBar": false
     }
    ]
   },
   {
    "label": "Quotations & Approvals",
    "icon": "fas fa-file-invoice-dollar",
    "bottomBar": false,
    "children": [
     {
      "label": "Approvals Queue & AP",
      "icon": "fas fa-check-double",
      "pageId": 73922,
      "bottomBar": true
     }
    ]
   },
   {
    "label": "Contractor Management",
    "icon": "fas fa-hard-hat",
    "bottomBar": false,
    "children": [
     {
      "label": "Trade Rate Cards",
      "icon": "fas fa-tags",
      "pageId": 73917,
      "bottomBar": false
     },
     {
      "label": "Performance Scorecards",
      "icon": "fas fa-medal",
      "pageId": 73926,
      "bottomBar": false
     }
    ]
   },
   {
    "label": "Hierarchy & Assets",
    "icon": "fas fa-building",
    "bottomBar": false,
    "children": [
     {
      "label": "Spatial Property Tree",
      "icon": "fas fa-sitemap",
      "pageId": 73925,
      "bottomBar": false
     },
     {
      "label": "Batch QR Placards",
      "icon": "fas fa-qrcode",
      "pageId": 73928,
      "bottomBar": false
     }
    ]
   },
   {
    "label": "Billing & Subscriptions",
    "icon": "fas fa-credit-card",
    "bottomBar": false,
    "children": [
     {
      "label": "Subscription & Seats",
      "icon": "fas fa-layer-group",
      "pageId": 73929,
      "bottomBar": false
     },
     {
      "label": "Invoicing & Payments",
      "icon": "fas fa-receipt",
      "pageId": 73930,
      "bottomBar": false
     }
    ]
   }
  ],
  "defaultPageId": 73923
 },
 "_provider-profile-accreditation-management-layout": {
  "items": [
   {
    "label": "Quotations & Approvals",
    "icon": "fas fa-file-invoice-dollar",
    "bottomBar": false,
    "children": [
     {
      "label": "Quotation Builder",
      "icon": "fas fa-calculator",
      "pageId": 73919,
      "bottomBar": false
     }
    ]
   },
   {
    "label": "Contractor Management",
    "icon": "fas fa-hard-hat",
    "bottomBar": false,
    "children": [
     {
      "label": "Trade Rate Cards",
      "icon": "fas fa-tags",
      "pageId": 73917,
      "bottomBar": false
     },
     {
      "label": "Provider Compliance",
      "icon": "fas fa-id-card",
      "pageId": 73918,
      "bottomBar": false
     }
    ]
   }
  ],
  "defaultPageId": null
 },
 "_role-permissions-security-policies-layout": {
  "items": [
   {
    "label": "System Administration",
    "icon": "fas fa-cogs",
    "bottomBar": false,
    "children": [
     {
      "label": "Users & Access Control",
      "icon": "fas fa-users-cog",
      "pageId": 73909,
      "bottomBar": false
     },
     {
      "label": "Security & Permissions",
      "icon": "fas fa-user-lock",
      "pageId": 73911,
      "bottomBar": false
     },
     {
      "label": "Audit Trail Explorer",
      "icon": "fas fa-shield-alt",
      "pageId": 73924,
      "bottomBar": false
     },
     {
      "label": "Tenant Branding",
      "icon": "fas fa-paint-brush",
      "pageId": 73927,
      "bottomBar": false
     },
     {
      "label": "Webhooks & Integrations",
      "icon": "fas fa-network-wired",
      "pageId": 73931,
      "bottomBar": false
     }
    ]
   },
   {
    "label": "Hierarchy & Assets",
    "icon": "fas fa-building",
    "bottomBar": false,
    "children": [
     {
      "label": "Spatial Property Tree",
      "icon": "fas fa-sitemap",
      "pageId": 73925,
      "bottomBar": false
     }
    ]
   },
   {
    "label": "Dashboards & Triage",
    "icon": "fas fa-tachometer-alt",
    "bottomBar": false,
    "children": [
     {
      "label": "Executive SLA Dashboard",
      "icon": "fas fa-chart-line",
      "pageId": 73923,
      "bottomBar": true
     }
    ]
   }
  ],
  "defaultPageId": 73923
 },
 "_spatial-hierarchy-property-tree-layout": {
  "items": [
   {
    "label": "System Administration",
    "icon": "fas fa-cogs",
    "bottomBar": false,
    "children": [
     {
      "label": "Users & Access Control",
      "icon": "fas fa-users-cog",
      "pageId": 73909,
      "bottomBar": false
     },
     {
      "label": "Security & Permissions",
      "icon": "fas fa-user-lock",
      "pageId": 73911,
      "bottomBar": false
     },
     {
      "label": "Audit Trail Explorer",
      "icon": "fas fa-shield-alt",
      "pageId": 73924,
      "bottomBar": false
     },
     {
      "label": "Tenant Branding",
      "icon": "fas fa-paint-brush",
      "pageId": 73927,
      "bottomBar": false
     },
     {
      "label": "Webhooks & Integrations",
      "icon": "fas fa-network-wired",
      "pageId": 73931,
      "bottomBar": false
     }
    ]
   },
   {
    "label": "Work Orders & Field",
    "icon": "fas fa-tools",
    "bottomBar": false,
    "children": [
     {
      "label": "Inspection Templates",
      "icon": "fas fa-clipboard-check",
      "pageId": 73932,
      "bottomBar": false
     }
    ]
   },
   {
    "label": "Contractor Management",
    "icon": "fas fa-hard-hat",
    "bottomBar": false,
    "children": [
     {
      "label": "Trade Rate Cards",
      "icon": "fas fa-tags",
      "pageId": 73917,
      "bottomBar": false
     }
    ]
   },
   {
    "label": "Hierarchy & Assets",
    "icon": "fas fa-building",
    "bottomBar": false,
    "children": [
     {
      "label": "Spatial Property Tree",
      "icon": "fas fa-sitemap",
      "pageId": 73925,
      "bottomBar": false
     },
     {
      "label": "Batch QR Placards",
      "icon": "fas fa-qrcode",
      "pageId": 73928,
      "bottomBar": false
     }
    ]
   },
   {
    "label": "Dashboards & Triage",
    "icon": "fas fa-tachometer-alt",
    "bottomBar": false,
    "children": [
     {
      "label": "Executive SLA Dashboard",
      "icon": "fas fa-chart-line",
      "pageId": 73923,
      "bottomBar": true
     }
    ]
   },
   {
    "label": "Billing & Subscriptions",
    "icon": "fas fa-credit-card",
    "bottomBar": false,
    "children": [
     {
      "label": "Subscription & Seats",
      "icon": "fas fa-layer-group",
      "pageId": 73929,
      "bottomBar": false
     },
     {
      "label": "Invoicing & Payments",
      "icon": "fas fa-receipt",
      "pageId": 73930,
      "bottomBar": false
     }
    ]
   }
  ],
  "defaultPageId": 73923
 },
 "_subscription-tier-seat-licensing-layout": {
  "items": [
   {
    "label": "System Administration",
    "icon": "fas fa-cogs",
    "bottomBar": false,
    "children": [
     {
      "label": "Users & Access Control",
      "icon": "fas fa-users-cog",
      "pageId": 73909,
      "bottomBar": false
     },
     {
      "label": "Tenant Branding",
      "icon": "fas fa-paint-brush",
      "pageId": 73927,
      "bottomBar": false
     }
    ]
   },
   {
    "label": "Work Orders & Field",
    "icon": "fas fa-tools",
    "bottomBar": false,
    "children": [
     {
      "label": "Inspection Templates",
      "icon": "fas fa-clipboard-check",
      "pageId": 73932,
      "bottomBar": false
     }
    ]
   },
   {
    "label": "Quotations & Approvals",
    "icon": "fas fa-file-invoice-dollar",
    "bottomBar": false,
    "children": [
     {
      "label": "Approvals Queue & AP",
      "icon": "fas fa-check-double",
      "pageId": 73922,
      "bottomBar": true
     }
    ]
   },
   {
    "label": "Contractor Management",
    "icon": "fas fa-hard-hat",
    "bottomBar": false,
    "children": [
     {
      "label": "Trade Rate Cards",
      "icon": "fas fa-tags",
      "pageId": 73917,
      "bottomBar": false
     }
    ]
   },
   {
    "label": "Hierarchy & Assets",
    "icon": "fas fa-building",
    "bottomBar": false,
    "children": [
     {
      "label": "Spatial Property Tree",
      "icon": "fas fa-sitemap",
      "pageId": 73925,
      "bottomBar": false
     },
     {
      "label": "Batch QR Placards",
      "icon": "fas fa-qrcode",
      "pageId": 73928,
      "bottomBar": false
     }
    ]
   },
   {
    "label": "Dashboards & Triage",
    "icon": "fas fa-tachometer-alt",
    "bottomBar": false,
    "children": [
     {
      "label": "Executive SLA Dashboard",
      "icon": "fas fa-chart-line",
      "pageId": 73923,
      "bottomBar": true
     }
    ]
   },
   {
    "label": "Billing & Subscriptions",
    "icon": "fas fa-credit-card",
    "bottomBar": false,
    "children": [
     {
      "label": "Subscription & Seats",
      "icon": "fas fa-layer-group",
      "pageId": 73929,
      "bottomBar": false
     },
     {
      "label": "Invoicing & Payments",
      "icon": "fas fa-receipt",
      "pageId": 73930,
      "bottomBar": false
     }
    ]
   }
  ],
  "defaultPageId": 73923
 },
 "_tenant-users-access-management-layout": {
  "items": [
   {
    "label": "System Administration",
    "icon": "fas fa-cogs",
    "bottomBar": false,
    "children": [
     {
      "label": "Users & Access Control",
      "icon": "fas fa-users-cog",
      "pageId": 73909,
      "bottomBar": false
     },
     {
      "label": "Security & Permissions",
      "icon": "fas fa-user-lock",
      "pageId": 73911,
      "bottomBar": false
     },
     {
      "label": "Audit Trail Explorer",
      "icon": "fas fa-shield-alt",
      "pageId": 73924,
      "bottomBar": false
     },
     {
      "label": "Tenant Branding",
      "icon": "fas fa-paint-brush",
      "pageId": 73927,
      "bottomBar": false
     },
     {
      "label": "Webhooks & Integrations",
      "icon": "fas fa-network-wired",
      "pageId": 73931,
      "bottomBar": false
     }
    ]
   },
   {
    "label": "Work Orders & Field",
    "icon": "fas fa-tools",
    "bottomBar": false,
    "children": [
     {
      "label": "Inspection Templates",
      "icon": "fas fa-clipboard-check",
      "pageId": 73932,
      "bottomBar": false
     }
    ]
   },
   {
    "label": "Contractor Management",
    "icon": "fas fa-hard-hat",
    "bottomBar": false,
    "children": [
     {
      "label": "Trade Rate Cards",
      "icon": "fas fa-tags",
      "pageId": 73917,
      "bottomBar": false
     }
    ]
   },
   {
    "label": "Hierarchy & Assets",
    "icon": "fas fa-building",
    "bottomBar": false,
    "children": [
     {
      "label": "Spatial Property Tree",
      "icon": "fas fa-sitemap",
      "pageId": 73925,
      "bottomBar": false
     },
     {
      "label": "Batch QR Placards",
      "icon": "fas fa-qrcode",
      "pageId": 73928,
      "bottomBar": false
     }
    ]
   },
   {
    "label": "Dashboards & Triage",
    "icon": "fas fa-tachometer-alt",
    "bottomBar": false,
    "children": [
     {
      "label": "Executive SLA Dashboard",
      "icon": "fas fa-chart-line",
      "pageId": 73923,
      "bottomBar": true
     }
    ]
   },
   {
    "label": "Billing & Subscriptions",
    "icon": "fas fa-credit-card",
    "bottomBar": false,
    "children": [
     {
      "label": "Subscription & Seats",
      "icon": "fas fa-layer-group",
      "pageId": 73929,
      "bottomBar": false
     },
     {
      "label": "Invoicing & Payments",
      "icon": "fas fa-receipt",
      "pageId": 73930,
      "bottomBar": false
     }
    ]
   }
  ],
  "defaultPageId": 73923
 },
 "_trade-categories-rate-cards-layout": {
  "items": [
   {
    "label": "System Administration",
    "icon": "fas fa-cogs",
    "bottomBar": false,
    "children": [
     {
      "label": "Users & Access Control",
      "icon": "fas fa-users-cog",
      "pageId": 73909,
      "bottomBar": false
     },
     {
      "label": "Tenant Branding",
      "icon": "fas fa-paint-brush",
      "pageId": 73927,
      "bottomBar": false
     }
    ]
   },
   {
    "label": "Work Orders & Field",
    "icon": "fas fa-tools",
    "bottomBar": false,
    "children": [
     {
      "label": "Inspection Templates",
      "icon": "fas fa-clipboard-check",
      "pageId": 73932,
      "bottomBar": false
     }
    ]
   },
   {
    "label": "Quotations & Approvals",
    "icon": "fas fa-file-invoice-dollar",
    "bottomBar": false,
    "children": [
     {
      "label": "Quotation Builder",
      "icon": "fas fa-calculator",
      "pageId": 73919,
      "bottomBar": false
     }
    ]
   },
   {
    "label": "Contractor Management",
    "icon": "fas fa-hard-hat",
    "bottomBar": false,
    "children": [
     {
      "label": "Trade Rate Cards",
      "icon": "fas fa-tags",
      "pageId": 73917,
      "bottomBar": false
     },
     {
      "label": "Provider Compliance",
      "icon": "fas fa-id-card",
      "pageId": 73918,
      "bottomBar": false
     }
    ]
   },
   {
    "label": "Hierarchy & Assets",
    "icon": "fas fa-building",
    "bottomBar": false,
    "children": [
     {
      "label": "Spatial Property Tree",
      "icon": "fas fa-sitemap",
      "pageId": 73925,
      "bottomBar": false
     },
     {
      "label": "Batch QR Placards",
      "icon": "fas fa-qrcode",
      "pageId": 73928,
      "bottomBar": false
     }
    ]
   },
   {
    "label": "Dashboards & Triage",
    "icon": "fas fa-tachometer-alt",
    "bottomBar": false,
    "children": [
     {
      "label": "Executive SLA Dashboard",
      "icon": "fas fa-chart-line",
      "pageId": 73923,
      "bottomBar": true
     }
    ]
   },
   {
    "label": "Billing & Subscriptions",
    "icon": "fas fa-credit-card",
    "bottomBar": false,
    "children": [
     {
      "label": "Subscription & Seats",
      "icon": "fas fa-layer-group",
      "pageId": 73929,
      "bottomBar": false
     },
     {
      "label": "Invoicing & Payments",
      "icon": "fas fa-receipt",
      "pageId": 73930,
      "bottomBar": false
     }
    ]
   }
  ],
  "defaultPageId": 73923
 },
 "_work-order-packaging-dispatch-board-layout": {
  "items": [
   {
    "label": "Dashboards & Triage",
    "icon": "fas fa-tachometer-alt",
    "bottomBar": false,
    "children": [
     {
      "label": "Kanban Triage Board",
      "icon": "fas fa-columns",
      "pageId": 73915,
      "bottomBar": true
     },
     {
      "label": "Executive SLA Dashboard",
      "icon": "fas fa-chart-line",
      "pageId": 73923,
      "bottomBar": true
     }
    ]
   },
   {
    "label": "Defect Intake",
    "icon": "fas fa-inbox",
    "bottomBar": false,
    "children": [
     {
      "label": "Service Desk Console",
      "icon": "fas fa-headset",
      "pageId": 73913,
      "bottomBar": false
     }
    ]
   },
   {
    "label": "Work Orders & Field",
    "icon": "fas fa-tools",
    "bottomBar": false,
    "children": [
     {
      "label": "Work Order Dispatch",
      "icon": "fas fa-clipboard-list",
      "pageId": 73916,
      "bottomBar": true
     },
     {
      "label": "Inspection Templates",
      "icon": "fas fa-clipboard-check",
      "pageId": 73932,
      "bottomBar": false
     },
     {
      "label": "Dual Sign-Off & Review",
      "icon": "fas fa-signature",
      "pageId": 73921,
      "bottomBar": true
     }
    ]
   },
   {
    "label": "Quotations & Approvals",
    "icon": "fas fa-file-invoice-dollar",
    "bottomBar": false,
    "children": [
     {
      "label": "Approvals Queue & AP",
      "icon": "fas fa-check-double",
      "pageId": 73922,
      "bottomBar": true
     }
    ]
   },
   {
    "label": "Contractor Management",
    "icon": "fas fa-hard-hat",
    "bottomBar": false,
    "children": [
     {
      "label": "Performance Scorecards",
      "icon": "fas fa-medal",
      "pageId": 73926,
      "bottomBar": false
     }
    ]
   }
  ],
  "defaultPageId": 73923
 }
};

// "Residents" (resident-directory) is not in the generated design menu. Rather than editing every tree above,
// it is inserted here: right after "Users & Access Control" where a layout has that item, otherwise at the end
// of the layout's "Defect Intake" group. AppShell filters the menu by role, so only roles that may open it see it.
const USERS_PAGE_ID = 73909;
const RESIDENTS_ITEM = { label: 'Residents', icon: 'fas fa-address-book', pageId: 90001, bottomBar: false };

const hasPage = (items, pageId) => items.some((item) => item.pageId === pageId || (item.children && hasPage(item.children, pageId)));

function insertAfterUsers(items) {
  return items.flatMap((item) => {
    if (item.pageId === USERS_PAGE_ID) return [item, RESIDENTS_ITEM];
    return [item.children ? { ...item, children: insertAfterUsers(item.children) } : item];
  });
}

function withResidents(menu) {
  if (hasPage(menu.items, RESIDENTS_ITEM.pageId)) return menu;
  if (hasPage(menu.items, USERS_PAGE_ID)) return { ...menu, items: insertAfterUsers(menu.items) };
  return {
    ...menu,
    items: menu.items.map((item) => (item.label === 'Defect Intake' && item.children ? { ...item, children: [...item.children, RESIDENTS_ITEM] } : item)),
  };
}

// The generated labels are too long for a single-row top bar and for phone tabs (they truncated or clamped).
// Short names are applied here, in one place, for every layout. Browser tab titles keep the full page names.
const SHORT_LABELS = {
  // groups
  'Dashboards & Triage': 'Triage',
  'Defect Intake': 'Intake',
  'Work Orders & Field': 'Work Orders',
  'Quotations & Approvals': 'Approvals',
  'Contractor Management': 'Contractors',
  'Hierarchy & Assets': 'Locations',
  'Billing & Subscriptions': 'Billing',
  'System Administration': 'Admin',
  // pages
  'Kanban Triage Board': 'Triage Board',
  'Executive SLA Dashboard': 'SLA Dashboard',
  'Service Desk Console': 'Service Desk',
  'Work Order Dispatch': 'Dispatch',
  'Approvals Queue & AP': 'Approvals & AP',
  'Performance Scorecards': 'Scorecards',
  'Users & Access Control': 'Users',
  'Security & Permissions': 'Permissions',
  'Webhooks & Integrations': 'Webhooks',
  'Audit Trail Explorer': 'Audit Trail',
  'Spatial Property Tree': 'Property Tree',
  'Batch QR Placards': 'QR Placards',
  'Subscription & Seats': 'Properties & plans',
  'Invoicing & Payments': 'Invoices',
  'Trade Rate Cards': 'Rate Cards',
  'Provider Compliance': 'Compliance',
  'Tenant Branding': 'Branding',
};

const shorten = (items) => items.map((item) => ({ ...item, label: SHORT_LABELS[item.label] || item.label, ...(item.children ? { children: shorten(item.children) } : {}) }));

// "Resident charges" (chargeable repairs) follows the same route: right after "Residents" where a layout has it,
// otherwise at the end of the layout's billing group. Layouts with neither are left as they are.
const BILLING_PAGE_IDS = [73929, 73930];
const CHARGES_ITEM = { label: 'Resident charges', icon: 'fas fa-file-invoice-dollar', pageId: 90002, bottomBar: false };

function insertAfterResidents(items) {
  return items.flatMap((item) => {
    if (item.pageId === RESIDENTS_ITEM.pageId) return [item, CHARGES_ITEM];
    return [item.children ? { ...item, children: insertAfterResidents(item.children) } : item];
  });
}

function withResidentCharges(menu) {
  if (hasPage(menu.items, CHARGES_ITEM.pageId)) return menu;
  if (hasPage(menu.items, RESIDENTS_ITEM.pageId)) return { ...menu, items: insertAfterResidents(menu.items) };
  const isBillingGroup = (item) => item.children && item.children.some((child) => BILLING_PAGE_IDS.includes(child.pageId));
  return { ...menu, items: menu.items.map((item) => (isBillingGroup(item) ? { ...item, children: [...item.children, CHARGES_ITEM] } : item)) };
}

// "Inspections" (carrying out a checklist in a unit) sits right after "Inspection Templates"; in a layout without
// it, right after the technician's jobs page so field staff still reach it.
const TEMPLATES_PAGE_ID = 73932;
const TECHNICIAN_PAGE_ID = 73920;
const INSPECTIONS_ITEM = { label: 'Inspections', icon: 'fas fa-clipboard-check', pageId: 90003, bottomBar: true };

function insertAfterPage(items, pageId, extra) {
  return items.flatMap((item) => {
    if (item.pageId === pageId) return [item, extra];
    return [item.children ? { ...item, children: insertAfterPage(item.children, pageId, extra) } : item];
  });
}

function withInspections(menu) {
  if (hasPage(menu.items, INSPECTIONS_ITEM.pageId)) return menu;
  const anchor = [TEMPLATES_PAGE_ID, TECHNICIAN_PAGE_ID].find((pageId) => hasPage(menu.items, pageId));
  return anchor ? { ...menu, items: insertAfterPage(menu.items, anchor, INSPECTIONS_ITEM) } : menu;
}

// "AssetOS" (the AssetOS add-on connector) sits right after "Tenant Branding" in the administration group.
const BRANDING_PAGE_ID = 73927;
const ASSETOS_ITEM = { label: 'AssetOS', icon: 'fas fa-boxes', pageId: 90004, bottomBar: false };

function withAssetOs(menu) {
  if (hasPage(menu.items, ASSETOS_ITEM.pageId) || !hasPage(menu.items, BRANDING_PAGE_ID)) return menu;
  return { ...menu, items: insertAfterPage(menu.items, BRANDING_PAGE_ID, ASSETOS_ITEM) };
}

// The generated design gave each page layout its own cut of the menu, so groups came and went as a user moved
// between pages. Every layout now shows the one complete tree (AppShell still filters it to what the role may
// open); a layout keeps only its own default page.
const COMPLETE_MENU = '_anonymous-web-layout';
const completeItems = shorten(withAssetOs(withInspections(withResidentCharges(withResidents(GENERATED_LAYOUT_MENUS[COMPLETE_MENU])))).items);

export const LAYOUT_MENUS = Object.fromEntries(Object.entries(GENERATED_LAYOUT_MENUS).map(([name, menu]) => [name, { ...menu, items: completeItems }]));
